export function CoverageStrip({ months }: { months: Array<{ ym: string; status: string }> }) {
  return (
    <div className="mt-2 flex gap-1" aria-label="12-month coverage strip">
      {months.map((month) => (
        <span key={month.ym} title={`${month.ym}: ${month.status}`} className={`h-3 flex-1 rounded-sm ${month.status === 'covered' ? 'bg-money-positive' : month.status === 'partial' ? 'bg-warning' : 'bg-muted'}`} />
      ))}
    </div>
  );
}

export default CoverageStrip;
